import { initializeApp } from "firebase/app";
import { getAnalytics, isSupported, logEvent } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyC5LzgVRvBCALWhkACFrUjgZWhN8WGjQeI",
  authDomain: "team-finease-consulting-llp.firebaseapp.com",
  projectId: "team-finease-consulting-llp",
  storageBucket: "team-finease-consulting-llp.firebasestorage.app",
  messagingSenderId: "737297791452",
  appId: "1:737297791452:web:3fad7db8d4f3eb2043b719",
  measurementId: "G-RS6R3HGF3P",
};

const app = initializeApp(firebaseConfig);

let analytics = null;

export async function initializeAnalytics() {
  try {
    const supported = await isSupported();
    if (supported) {
      analytics = getAnalytics(app);
    }
  } catch {
    // Ignore analytics init failures for unsupported browsers/privacy mode.
  }
  return analytics;
}

function sanitizeParams(params = {}) {
  const clean = {};
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null) return;
    if (typeof value === "string") {
      clean[key] = value.slice(0, 100);
      return;
    }
    if (typeof value === "number" || typeof value === "boolean") {
      clean[key] = value;
    }
  });
  return clean;
}

export async function trackEvent(eventName, params = {}) {
  try {
    const instance = analytics || (await initializeAnalytics());
    if (!instance) return;
    logEvent(instance, eventName, sanitizeParams(params));
  } catch {
    // Never block UI on analytics errors.
  }
}

export async function trackPageView(pagePath, pageTitle = "") {
  await trackEvent("page_view", {
    page_path: pagePath,
    page_title: pageTitle || document.title || "",
    page_location: window.location.href,
  });
}

export async function trackException(description, fatal = false) {
  await trackEvent("exception", {
    description,
    fatal,
  });
}

export { app, analytics };
